import { FetchContext } from 'context/FetchContext';
import { useContext } from 'react';
import { useMutation, useQueryClient } from 'react-query';

function useDeleteEST() {
  const queryClient = useQueryClient();
  const fetchContext = useContext(FetchContext);
  const { privateFetch } = fetchContext;

  function deleteEST(estID) {
    return privateFetch.delete(`/v1/admin/est/${estID}`);
  }

  function manageEST(data = {}) {
    return deleteEST(data.estID);
  }

  return useMutation(manageEST, {
    onSuccess() {},
    onSettled() {
      // this will invalidate all queries starting with 'est-lists'
      queryClient.invalidateQueries('est-lists');
    },
  });
}

export default useDeleteEST;
